// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../node_modules/@angular-devkit/build-angular/node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/@angular-devkit/build-angular/node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.modal-content .cald-modal-container {
  width: 75rem;
}
.modal-content .cald-modal-container .cald-modal-body {
  max-height: 100vh;
}
.modal-content .cald-modal-container .cald-modal-body .salesforce-item {
  padding-top: 2rem;
  padding-top: 2rem;
  border-radius: 0.4rem;
  border: solid 0.1rem #e5e5e5;
  color: #32363a;
  font-size: 1.4rem;
  padding: 0.8rem;
  /* height: 2.6rem; */
  background-color: #fff;
  margin-bottom: 1rem;
  width: 100%;
}
.modal-content .cald-modal-container .cald-modal-body .salesforce-item .salesforce-id {
  margin-left: 1.5rem;
}
.modal-content .cald-modal-container .cald-modal-body .salesforce-item .org-item {
  padding: 1.5rem 0 0 1rem !important;
}
.modal-content .cald-modal-container .cald-modal-body .salesforce-item .check-icon {
  top: 3.1rem;
}
.modal-content .cald-modal-container .cald-modal-body .downlineTxtCls {
  margin: 1rem 0 1rem;
  text-align: center;
  font-size: 1.4rem;
}`, "",{"version":3,"sources":["webpack://./src/app/shared/change-organization-downline/change-org-downline-confirmation-modal.component.scss"],"names":[],"mappings":"AACE;EACE,YAAA;AAAJ;AAEI;EACE,iBAAA;AAAN;AAEM;EACE,iBAAA;EAGA,iBAAA;EACA,qBAAA;EACA,4BAAA;EACA,cAAA;EACA,iBAAA;EACA,eAAA;EACA,oBAAA;EACA,sBAAA;EACA,mBAAA;EACA,WAAA;AAFR;AAIQ;EACE,mBAAA;AAFV;AAIQ;EACE,mCAAA;AAFV;AAIQ;EACE,WAAA;AAFV;AAMM;EACE,mBAAA;EACA,kBAAA;EACA,iBAAA;AAJR","sourcesContent":[".modal-content {\n  .cald-modal-container {\n    width: 75rem;\n\n    .cald-modal-body {\n      max-height: 100vh;\n\n      .salesforce-item {\n        padding-top: 2rem;\n        // text-align: center;\n        // margin-right: 9rem;\n        padding-top: 2rem;\n        border-radius: 0.4rem;\n        border: solid 0.1rem #e5e5e5;\n        color: #32363a;\n        font-size: 1.4rem;\n        padding: 0.8rem;\n        /* height: 2.6rem; */\n        background-color: #fff;\n        margin-bottom: 1rem;\n        width: 100%;\n\n        .salesforce-id {\n          margin-left: 1.5rem;\n        }\n        .org-item {\n          padding: 1.5rem 0 0 1rem !important;\n        }\n        .check-icon {\n          top: 3.1rem;\n        }\n      }\n      \n      .downlineTxtCls {\n        margin: 1rem 0 1rem;\n        text-align: center;\n        font-size: 1.4rem;\n      }\n    }\n  }\n}"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
